module.exports = __webpack_public_path__ + "static/media/edinburgh_8.ed9f6900.png";